import axios from "../util/axios";
// 通用接口，没有权限限制
export default {
    /** 退出登录 */
    logout: () => axios.del({url: "/basedata/common/logout"}),
    /** 获取登录用户信息 */
    getUserInfo: () => axios.get({url: "/basedata/common/getUserInfo"}),
    /** 查询角色可用菜单 */
    getMenu: (systemType, menuType) => axios.get({url: "/basedata/common/getMenu", data: {systemType, menuType}}),
    /** 查询全部商户信息 */
    findSetting: (code) => axios.get({url: `/basedata/common/findSetting`, data: {code}}),
    /**查询列显示字段*/
    queryColumnSetting: () => axios.get({url: "/basedata/common/queryColumnSetting", }),
    /**保存*/
    saveColumnSetting: (data) => axios.post({url: "/basedata/common/saveColumnSetting", data: data}),
    /**树形字典*/
    queryDictionaryTree: (type, merchantId) => axios.get({url: "/basedata/common/queryDictionaryTree", data: {type, merchantId}}),
    /** 查询上游商户的配置信息，某些配置只允许一级代理进行配置，比如小程序页面 */
    findParentSetting: (code) => axios.get({url: `/basedata/common/findParentSetting`, data: {code}}),
    /** 查询全部职员信息 */
    queryEmployeeList: (data) => axios.get({url: `/basedata/common/queryEmployeeList`, data}),
    /** 收藏常用功能*/
    queryEmployeeCollection: () => axios.get({url: `/basedata/common/queryEmployeeCollection`}),
    /** 添加收藏功能*/
    saveEmployeeCollection: (data) => axios.post({url: `/basedata/common/saveEmployeeCollection`, data: data}),
    /** 删除收藏功能*/
    deleteEmployeeCollection: (id) => axios.del({url: `/basedata/common/deleteEmployeeCollection`, data: {id}}),
    /** 收藏功能排序*/
    indexEmployeeCollection: (data) => axios.post({url: `/basedata/common/indexEmployeeCollection`, data: data}),
    /**字典列表*/
    queryDictionaryList: (type, merchantId) => axios.get({url: "/basedata/common/queryDictionaryList", data: {type, merchantId}}),
    /**唯一字典表*/
    queryUniqueDictionaryList: (type, merchantId) => axios.get({url: "/basedata/common/queryUniqueDictionaryList", data: {type, merchantId}}),
    /** 职员信息分页 */
    queryEmployeeListByPage: (data) => axios.get({url: `/basedata/common/queryEmployeeListByPage`, data}),
    /** 查询全部角色 */
    queryAllRole: () => axios.get({url: "/basedata/common/queryAllRole"}),
    /**根据id，查询多个职员*/
    queryEmployeeByIds: (ids) => axios.post({url: "/basedata/common/queryEmployeeByIds", data: ids}),
    /** 获取默认天气 */
    findWeather: () => axios.get({url: `/basedata/common/findWeather`, }),
    /** 根据定位获取天气 */
    findWeatherByLocation: (lng, lat) => axios.get({url: `/basedata/common/findWeatherByLocation`, data: {lng, lat}}),
    /**查询部门信息*/
    queryDepartList: () => axios.get({url: "/basedata/common/queryDepartList"}),
    /**切换角色*/
    switchRole: (roleId) => axios.get({url: "/basedata/common/switchRole", data: {roleId}}),
    /**
     * 查询已对接工作流的业务清单（字典）。
     * 消息模板/消息设置/消息开关、工作流列表、送审中心共用这一份字典，故放在通用接口。
     */
    queryBusinessTemplateList: () => axios.get({url: "/basedata/common/businessTemplate/queryList"}),




    /** 企业微信config参数*/
    getConfigSignature: (url, merchantId) => axios.get({url: "/wx/common/getConfigSignature", data: {url, merchantId}}),
    /** 企业微信agentConfig参数*/
    getAgentConfigSignature: (url, merchantId) => axios.get({url: "/wx/common/getAgentConfigSignature", data: {url, merchantId}}),
    /** 查询文件列表 */
    queryFileList: (folder) => axios.get({url: "/basedata/common/file/queryFileList", data: {folder}}),
    /** 上传文件 */
    deleteFile: (fileName) => axios.get({url: "/basedata/common/file/deleteFile", data: {fileName}}),
    /** 更新头像 */
    updateAvatar: (iconUrl, id) => axios.get({url: `/basedata/common/updateAvatar`, data: {iconUrl, id}}),
    /** 更改用户基本信息 */
    updateUserInfo: (data) => axios.post({url: `/basedata/common/updateUserInfo`, data: data}),

    /** 修改密码 */
    changePasswordV2: (passwordForm) => axios.post({url: "/basedata/common/changePasswordV2", data: passwordForm}),

    /*往来单位接口*/
    /** 查询客户信息 */
    findCustomerInfo: (id) => axios.get({url: `/basedata/common/partner/findCustomerInfo`, data: {id}}),
    /** 批量查询客户信息，分页查询 */
    queryCustomerListByPage: (data) => axios.get({url: `/basedata/common/partner/queryCustomerListByPage`, data}),
    /** 查询供应商信息 */
    findSupplierInfo: (id) => axios.get({url: `/basedata/common/partner/findSupplierInfo`, data: {id}}),
    /** 批量查询供应商信息，分页查询 */
    querySupplierListByPage: (data) => axios.get({url: `/basedata/common/partner/querySupplierListByPage`, data}),

    /*消息接口*/
    /** 批量阅读消息 */
    readNotice: (deviceType, ids) => axios.post({url: `/basedata/common/message/readNotice?type=${deviceType}`, data: ids}),
    /** 系统通知列表，分页查询 */
    queryMySystemProclamation: (data) => axios.get({url: "/basedata/common/message/queryMySystemProclamation", data}),
    /** 系统消息详情 */
    findSystemMessage: (id) => axios.get({url: "/basedata/common/message/findSystemMessage", data: {id}}),
    /** 系统消息提醒，分页查询 */
    queryMySystemNotice: (data) => axios.get({url: "/basedata/common/message/queryMySystemNotice", data}),

    /*erp相关接口*/
    /** 往来单位分类树 */
    queryBtypeCategory: () => axios.get({url: "/basedata/common/erp/queryBtypeCategory", }),
    /**查询往来单位列表*/
    queryBtypeByPage: (data) => axios.get({url: "/basedata/common/erp/queryBtypeByPage", data}),
    /**查询往来单位客户联系人列表*/
    queryBtypeExternalByPage: (data) => axios.get({url: "/basedata/common/erp/queryBtypeExternalByPage", data}),
    /**往来单位的信息*/
    findBtypeInfo: (typeId) => axios.get({url: `/basedata/common/erp/findBtypeInfo`, data: {typeId}}),

    /*商户接口*/
    /** 查询登录人的商户信息 */
    findMerchantBuildInfo: () => axios.get({url: `/wx/common/findQywxInfo`, }),
    /** 查询全部商户信息 */
    queryAllMerchants: () => axios.get({url: `/basedata/common/merchant/queryAllMerchants`, }),
    /**商户已开通的服务*/
    queryMerchantService: () => axios.get({url: `/basedata/common/merchant/queryMerchantService`, }),
    /*自定义字段接口*/
    /**自定义字段，是否支持*/
    queryCustomerTableAble: (data) => axios.get({url: `/basedata/common/table/customerTableAble`, data}),
    /**自定义表格列表*/
    customerTableList: (pageName) => axios.get({url: `/basedata/common/table/customerTableList`, data: {pageName}}),


    /*路桥*/
    /** 按工地统计劳务人员 */
    contractWorkerSiteCount: (data) => axios.get({url: "/luqiao/common/contractWorkerSiteCount", data}),
    /** 劳务人员昨天打卡统计 */
    contractWorkerAttendanceList: (data) => axios.get({url: "/luqiao/common/contractWorkerAttendanceList", data}),
    /**路桥首页统计数据*/
    luqiaoHomeStatistic: () => axios.get({url: "/luqiao/common/home/statistic"}),
    /** 按职业类型统计劳务人员 */
    contractWorkerTypeCount: () => axios.get({url: "/luqiao/common/contractWorkerTypeCount",}),
    /** 系统预警消息 */
    queryWarnList: (params) => axios.get({url: "/basedata/common/warn/list", data: params}),
    /**路桥首页监控数据*/
    luqiaoMonitorAdmin: () => axios.get({url: "/luqiao/common/monitor/findDataAdmin"}),
    luqiaoMonitorMember: () => axios.get({url: "/luqiao/common/monitor/findDataMember"}),


}

